var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"swiper",rawName:"v-swiper:carouselArticles",value:(_vm.swiperOption),expression:"swiperOption",arg:"carouselArticles"}],staticClass:"articles pb-4"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.articles),function(article){return _c('carousel-article',{key:article.slug,attrs:{"article":article}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }